const teamData = [
  {
    name: 'Jaikishan Dulani',
    position: 'Think Thank',
    image: '/images/jaikishan.jpeg',
    social: {
      facebook: 'https://www.facebook.com/dulani.jaikishan/',
      linkedin: 'https://www.linkedin.com/in/jaikishan-dulani/',
      twitter: 'https://twitter.com/JaikishanDulani/',
      instagram: 'https://www.instagram.com/offbeat_geek/',
    },
    about: `I am a tech enthusiast who doesn’t like to code, hence the designation Non-Coder. I strategize, plan and execute the non coding part at Kahan Chale. I am also an avid traveler who has traveled to 24 countries before graduating from IIT Madras.`,
  },
  {
    name: 'Aman Dugar',
    position: 'Executioner',
    image: '/images/aman.jpg',
    social: {
      facebook: 'https://www.facebook.com/aman.dugar.77/',
      linkedin: 'https://www.linkedin.com/in/amandugar/',
      twitter: 'https://twitter.com/amandugar25',
      instagram: 'https://www.instagram.com/aman._dugar/',
    },
    about: `I am a Developer who is always into Coding which justifies my designation Coder. I implement the Strategies build and make them functional and ideal. Being a CSE Student from Amity University Jaipur I want to learn as much as possible before graduation.`,
  },
]

export default teamData
